/* global define */

define([
  'es6!sumo/util',
  'immutable',
  'underscore',
  'es6!launcher/actions/Actions',
], (Util, Immutable, _, Actions) => {
  const initialState = Immutable.Map({
    notifications: Immutable.List(),
    loadingNotifications: true,
    count: 0,
    limit: 10,
    fetchedAt: new Date(),
  });

  const actionHandlers = {};

  actionHandlers[Actions.RECEIVE_NOTIFICATIONS] = (state, action) => {
    const { notifications, notification_count, limit } = action.data;
    const currentNotifications = state.get('notifications');
    const notificationsList = Immutable.fromJS(notifications || []);

    return state.merge(Immutable.Map({
      notifications: currentNotifications.concat(notificationsList),
      loadingNotifications: false,
      count: notification_count,
      limit,
    }));
  };

  actionHandlers[Actions.UPDATE_NOTIFICATIONS] = (state, action) => {
    return state.setIn([action.key], action.value);
  }

  actionHandlers[Actions.REQUEST_NOTIFICATIONS] = (state, action) => {
    return state.setIn(['loadingNotifications'], true);
  };

  return Util.createReducer(initialState, actionHandlers);
});

